import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api'

import { GET_GUESTS_BASE_QUERY_KEY } from './get-guests'

type UpdateVisitorGuestRequest = {
  id: number
  formData: FormData
}

const updateVisitorGuest = async ({ id, formData }: UpdateVisitorGuestRequest): Promise<void> => {
  await authAPI.put(`/client/guest/${id}`, formData)
}

export const useUpdateVisitorGuest = () => {
  return useMutation({
    mutationFn: updateVisitorGuest,
    onSuccess: async () => {
      await resetQueries([GET_GUESTS_BASE_QUERY_KEY])
    },
  })
}
